import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import { ChildModal, StickySection, useModal } from 'cat-ecommerce-alloy';
import { useBreakpoint } from '@app/hooks';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import cx from 'classnames';
import useConflictNotes from '../common/hooks/useConflictNotes';
import Notes from '../Notes';
import CancelMergeModal from '../common/modals/CancelMergeModal';
import ModalButtonCTA from '../common/buttons/ModalButtonCTA';
import style from '../styles.module.scss';

const ResolutionForm = ({
  partList,
  onModalClose,
  initialValues,
  key,
  isOpen,
  close
}) => {
  const [t] = useTranslation();
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.LG);
  const ResolutionHeightClass = isLG
    ? style['resolution-height-desktop']
    : style['resolution-height-mobile'];
  const { onSaveDispatch } = useConflictNotes();
  const onSubmit = val => {
    onSaveDispatch(val, onModalClose);
  };
  const cancelMergeModalProps = useModal({
    isChild: true,
    parentIsOpen: isOpen
  });

  return (
    <>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {() => {
          return (
            <Form>
              <div
                className={cx(
                  'mb-3 me-2',
                  style['resolution__form-container'],
                  `${ResolutionHeightClass}`
                )}
              >
                <Notes partList={partList} key={key} />
              </div>
              <StickySection
                className={cx(
                  'd-flex justify-content-end align-items-center bg-white px-3',
                  style['resolution__sticky-container']
                )}
              >
                <ModalButtonCTA
                  btnTitle={t('CANCEL')}
                  btnType="ghost"
                  className="me-2"
                  type="button"
                  onClick={() => {
                    cancelMergeModalProps.open();
                  }}
                />
                <ModalButtonCTA
                  btnTitle={t('SAVE')}
                  btnType="primary"
                  type="submit"
                />
              </StickySection>
            </Form>
          );
        }}
      </Formik>
      <ChildModal
        title={t('CANCEL_MERGE')}
        backButtonMessage={t('BACK_TO_PREFERRED_NOTE')}
        {...cancelMergeModalProps}
        className={'d-flex flex-column me-4'}
      >
        <CancelMergeModal parentModalClose={close} {...cancelMergeModalProps} />
      </ChildModal>
    </>
  );
};
ResolutionForm.propTypes = {
  partList: PropTypes.arrayOf(
    PropTypes.shape({
      partNumber: PropTypes.string,
      partName: PropTypes.string,
      quantity: PropTypes.string,
      isPartNumberDisplay: PropTypes.bool,
      lineItemNotes: PropTypes.shape({})
    })
  ),
  onModalClose: PropTypes.func,
  initialValues: PropTypes.arrayOf(PropTypes.shape({})),
  key: PropTypes.string,
  isOpen: PropTypes.bool,
  close: PropTypes.func
};

export default ResolutionForm;
